// src/components/Footer.js
import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
 <footer className="py-16 px-6 md:px-20 bg-[#05040f] border-t border-white/5">
        <div className="max-w-6xl mx-auto grid md:grid-cols-4 gap-8 items-start">
          <div>
            <div className="flex items-center gap-3">
              <img
                src="/logo.png"
                alt="smsorbit"
                className="w-10 h-10 rounded-xl"
              />
              <div>
                <div className="font-bold text-lg">SMSOrbit</div>
                <div className="text-xs text-gray-400">
                  Premium SMM Automation Panel.
                </div>
                <p className="text-sm text-slate-300 mt-4">
                  Support:{" "}
                  <a
                    href="mailto:support@smsorbit.in"
                    className="text-purple-400 font-medium hover:underline"
                  >
                    support@smsorbit.in
                  </a>
                </p>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-semibold mb-3">Navigation</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>
                <Link to="/features">Features</Link>
              </li>
              <li>
                <Link to="/services">Services</Link>
              </li>
              <li>
                <Link to="/blogs">Blog</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3">Legal</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>
                <Link to="/terms">Terms</Link>
              </li>
              <li>
                <Link to="/privacy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/refund">Refunds</Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-semibold mb-3">Developers</h4>
            <ul className="space-y-2 text-sm text-gray-300">
              <li>
                <Link to="/api-docs">API Documentation</Link>
              </li>
            </ul>
          </div>
        </div>
              <div className="border-t border-white/10 py-4 text-center text-xs text-slate-400">
        © {new Date().getFullYear()} SMSOrbit. All rights reserved.
      </div>
      </footer>
  );
};

export default Footer;
